import common from './common';
import main from './main';

const vi = { common, main };
export default vi;
